module.exports = __webpack_public_path__ + "img/libyan_labs_logo_dark_bg.770fd9a8.png";